import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { InactivityService } from '../services/inactivity.service';

@Injectable({ providedIn: 'root' })
export class AlreadyLoggedInGuard implements CanActivate {

  constructor(private router: Router, private inactivity: InactivityService) {}

  canActivate(): boolean {
    const token = localStorage.getItem('authToken');
    const role  = localStorage.getItem('role');

    if (token && role) {
      const dashboardMap: Record<string, string> = {
        admin:      '/admin/dashboard',
        instructor: '/instructor/dashboard',
        student:    '/student/dashboard',
      };
      this.router.navigate([dashboardMap[role] || '/student/dashboard']);
      return false;
    }

    this.inactivity.stop(); // ← stop the timer if not logged in
    return true;
  }
}